// extracted by mini-css-extract-plugin
export var backgroundImg = "videowithbackground-module--backgroundImg--4bce6";
export var backgroundPicture = "videowithbackground-module--backgroundPicture--11cd9";
export var fadeInAnimation = "videowithbackground-module--fadeInAnimation--65065";
export var video = "videowithbackground-module--video--ba77c";
export var wrapper = "videowithbackground-module--wrapper--f0c04";